export default {
  state: {
    object: {},
    objectsList: []
  },
  mutations: {
    setValue (state, keyValue) {
      state[keyValue.key] = keyValue.value
    }
  },
  actions: {
    SET_OBJECTS_LIST ({
      commit
    }, objectsList) {
      if (objectsList !== null && objectsList !== undefined) {
        commit('setValue', {
          key: 'object',
          value: objectsList
        })
      } else {
        commit('setValue', {
          key: 'object',
          value: []
        })
      }
    }
  },
  getters: {
    OBJECT: state => {
      if (state.object !== undefined) {
        return state.object
      } else {
        return null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/storages/modules/objectStore.js